<!-- ─── Main Assign / Edit Modal ─────────────────────────────────────────── -->
<p-dialog
  [(visible)]="visible"
  (onHide)="close()"
  [header]="modalHeader"
  [modal]="true"
  [style]="{ width: '500px' }"
  [draggable]="false"
  [resizable]="false"
>
  <div class="adm-body">
    <!-- Driver card / skeleton -->
    <div class="adm-driver-card">
      <div *ngIf="isLoadingDriverDetail" class="driver-card-skeleton">
        <div class="skeleton-avatar"></div>
        <div class="skeleton-lines">
          <div class="skeleton-line skeleton-line-lg"></div>
          <div class="skeleton-line skeleton-line-sm"></div>
        </div>
      </div>
      <app-driver-card
        *ngIf="!isLoadingDriverDetail && driverDetail"
        [driver]="driverDetail"
        [inline]="true"
      ></app-driver-card>
    </div>

    <!-- Loading teams indicator -->
    <div *ngIf="isLoadingTeams" class="adm-teams-loading">
      <i class="fa fa-spinner fa-spin"></i> Loading&hellip;
    </div>

    <ng-container *ngIf="!isLoadingTeams">
      <!-- Scheduling Team -->
      <div class="form-group mb-3">
        <label class="form-label mb-1">Scheduling Team <span class="text-danger">*</span></label>
        <p-dropdown
          [options]="schedulingTeams"
          [(ngModel)]="selectedTeamId"
          optionLabel="name"
          optionValue="id"
          placeholder="Select Scheduling Team"
          [filter]="true"
          filterBy="name,clientName"
          [style]="{ width: '100%', 'max-width': '420px' }"
          appendTo="body"
          (onChange)="onTeamChange()"
        >
          <ng-template let-team pTemplate="item">
            <div>
              {{ team.name }} <span class="text-muted">({{ team.clientName }})</span>
            </div>
          </ng-template>
        </p-dropdown>
        <div *ngIf="selectedTeamBanned" class="adm-banned-warning" role="alert">
          <i class="fa fa-exclamation-triangle"></i>
          This driver is banned from client &quot;{{ selectedTeam?.clientName }}&quot; and cannot be
          assigned to this scheduling group.
        </div>
      </div>

      <!-- Board -->
      <div class="form-group mb-3" *ngIf="selectedTeamId">
        <label class="form-label mb-1">Board</label>
        <p-dropdown
          [options]="availableBoards"
          [(ngModel)]="selectedBoardId"
          optionLabel="name"
          optionValue="id"
          placeholder="Select Board"
          [showClear]="true"
          [style]="{ width: '100%', 'max-width': '420px' }"
          appendTo="body"
        ></p-dropdown>
      </div>

      <!-- Bill To Client -->
      <div class="form-group mb-3" *ngIf="selectedTeamId">
        <label class="form-label mb-1">Bill To Client</label>
        <p-dropdown
          [options]="availableBillToClients"
          [(ngModel)]="selectedBillToId"
          optionLabel="companyName"
          optionValue="id"
          placeholder="Select Bill To Client"
          [showClear]="true"
          [filter]="true"
          filterBy="companyName"
          [style]="{ width: '100%', 'max-width': '420px' }"
          appendTo="body"
        ></p-dropdown>
      </div>

      <!-- Tractor -->
      <div class="form-group mb-3">
        <label class="form-label mb-1">Tractor</label>
        <p-dropdown
          [options]="tractors"
          [(ngModel)]="selectedTractorId"
          optionLabel="unitNumber"
          optionValue="id"
          placeholder="Select Tractor"
          [showClear]="true"
          [filter]="true"
          filterBy="unitNumber"
          [style]="{ width: '100%', 'max-width': '420px' }"
          appendTo="body"
          (onChange)="onEquipmentChange()"
        ></p-dropdown>
      </div>

      <!-- Trailer -->
      <div class="form-group mb-3">
        <label class="form-label mb-1">Trailer</label>
        <p-dropdown
          [options]="trailers"
          [(ngModel)]="selectedTrailerId"
          optionLabel="trailerNo"
          optionValue="id"
          placeholder="Select Trailer"
          [showClear]="true"
          [filter]="true"
          filterBy="trailerNo"
          [style]="{ width: '100%', 'max-width': '420px' }"
          appendTo="body"
          (onChange)="onEquipmentChange()"
        ></p-dropdown>
      </div>

      <!-- Notify checkbox -->
      <div class="adm-notify-row" *ngIf="selectedTeamId && emailFeaturesEnabled">
        <input type="checkbox" id="adm-notify-chk" [(ngModel)]="notifyOnAssign" />
        <label for="adm-notify-chk"> Notify </label>
      </div>
    </ng-container>
  </div>

  <p-footer>
    <div class="adm-footer">
      <button
        class="btn btn-danger"
        *ngIf="isEditMode"
        (click)="unassign()"
        [disabled]="isSubmitting"
        title="Remove driver from scheduling team"
      >
        <i class="fa fa-user-times"></i> Unassign
      </button>
      <div class="adm-footer-actions">
        <button class="btn btn-secondary" (click)="close()" [disabled]="isSubmitting">
          Cancel
        </button>
        <button
          class="btn btn-primary"
          (click)="confirm()"
          [disabled]="!selectedTeamId || isSubmitting"
        >
          <i class="fa fa-spin fa-spinner" *ngIf="isSubmitting"></i>
          {{ isSubmitting ? "Saving\u2026" : isEditMode ? "Update Assignment" : "Assign Driver" }}
        </button>
      </div>
    </div>
  </p-footer>
</p-dialog>

<!-- ─── Email Compose Modal ──────────────────────────────────────────────── -->
<p-dialog
  *ngIf="showEmailCompose"
  [(visible)]="showEmailCompose"
  header="Notify Scheduling Team"
  [modal]="true"
  [style]="{ width: '520px' }"
  [draggable]="false"
  [resizable]="false"
>
  <div class="adm-email-compose">
    <div class="form-group mb-3">
      <label class="form-label mb-1">To</label>
      <input type="text" class="form-control" [(ngModel)]="emailTo" placeholder="" />
    </div>
    <div class="form-group mb-3">
      <label class="form-label mb-1">CC</label>
      <input type="text" class="form-control" [(ngModel)]="emailCc" placeholder="" />
    </div>
    <div class="form-group mb-3">
      <label class="form-label mb-1">BCC</label>
      <input
        type="text"
        class="form-control"
        [(ngModel)]="emailBcc"
        placeholder="contact@example.com; &hellip;"
      />
      <small class="text-muted" *ngIf="!emailBcc">
        No contactable email addresses found on the scheduling team or driver.
      </small>
    </div>
    <div class="form-group mb-3">
      <label class="form-label mb-1">Subject</label>
      <input type="text" class="form-control" [(ngModel)]="emailSubject" />
    </div>
    <div class="form-group mb-3">
      <label class="form-label mb-1">Body</label>
      <textarea class="form-control" rows="4" [(ngModel)]="emailBody"></textarea>
    </div>
  </div>

  <p-footer>
    <div class="footer">
      <button class="btn btn-secondary" (click)="closeEmailCompose()" [disabled]="isSendingEmail">
        Cancel
      </button>
      <button
        class="btn btn-primary"
        (click)="sendEmail()"
        [disabled]="isSendingEmail || !emailFeaturesEnabled"
      >
        <i class="fa fa-spin fa-spinner" *ngIf="isSendingEmail"></i>
        <i class="fa fa-envelope" *ngIf="!isSendingEmail"></i>
        {{ isSendingEmail ? "Sending\u2026" : "Send" }}
      </button>
    </div>
  </p-footer>
</p-dialog>

<!-- ─── Customer Training Notes Modal ───────────────────────────────────── -->
<p-dialog
  *ngIf="showTrainingNotes"
  [(visible)]="showTrainingNotes"
  header="Customer Training Requirements"
  [modal]="true"
  [style]="{ width: '500px' }"
  [draggable]="false"
  [resizable]="false"
  [closeOnEscape]="true"
>
  <div class="adm-training-notes-body">
    <p class="text-muted" *ngIf="trainingNotesClientName">
      <strong>{{ trainingNotesClientName }}</strong> has the following training requirements for
      drivers:
    </p>
    <div class="adm-training-notes-content">{{ trainingNotesContent }}</div>
  </div>

  <p-footer>
    <button class="btn btn-primary" (click)="dismissTrainingNotes()">
      <i class="fa fa-check"></i> Acknowledge
    </button>
  </p-footer>
</p-dialog>
